import React from 'react';
import '../../styles/Footer.css';

const Footer = () => {
  return (
    <div className="footer">
      <div className="clear">&#160;</div>
    </div>
  );
};

export default Footer;